import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';

type UseSignalRListenerOptions = {
    url: string;
    method: string; // tên sự kiện (ví dụ: "ReceiveData")
    headers?: Record<string, string | undefined>; // thêm headers tuỳ chọn
};

function getCleanHeaders(headers?: Record<string, string | undefined>): Record<string, string> | undefined {
    if (!headers) return undefined;
    const clean: Record<string, string> = {};
    Object.entries(headers).forEach(([k, v]) => {
        if (typeof v === 'string') clean[k] = v;
    });
    return Object.keys(clean).length > 0 ? clean : undefined;
}

export function useSignalRListener<T = any>({
    url,
    method,
    headers,
}: UseSignalRListenerOptions) {
    const [data, setData] = useState<T | null>(null);

    useEffect(() => {
        let connection: signalR.HubConnection;
        const cleanHeaders = getCleanHeaders(headers);
        if (cleanHeaders) {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(url, { headers: cleanHeaders })
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Warning)
                .build();
        } else {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(url)
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Warning)
                .build();
        }

        connection.start()
            .then(() => {
                console.log('Connected to SignalR');
                connection.on(method, (incomingData: T) => {
                    setData(incomingData);
                });
            })
            .catch(err => {
                console.error('SignalR connection error:', err);
            });

        return () => {
            connection.off(method);
            connection.stop();
        };
    }, [url, method]);

    return data;
}
